export default "__VITE_ASSET__e38e02e2__"